<template>
  <div>
    <p>{{description}}</p>

    <div v-for="visa in visas" :key="visa.id">
      <Input
        :name="visa.id"
        :label="`${visa.name} - ${currency(visa.price)}`"
        placeholder="Please select"
        :required="true"
        :startingValue="startingValue(visa)"
        :options="[visaOptions.required, visaOptions.notRequired]"
        :vuexPath="vuexPath"
      />
    </div>
  </div>
</template>

<script>
import Input from '@/vue/components/Form/Input.vue';
import { visaOptions } from '@/config';

export default {
  components: {
    Input
  },

  props: ['description', 'visas', 'vuexPath', 'currency', 'selectedVisas'],

  data() {
    return {
      visaOptions
    };
  },

  methods: {
    startingValue(visa) {
      // check if the visa id exists in the array of selected ids
      if (
        this.selectedVisas &&
        this.selectedVisas.length &&
        this.selectedVisas.indexOf(visa.id) > -1
      ) {
        return this.visaOptions.required;
      }
      return '';
    }
  }
};
</script>